<template>
  <div class="chart-container">
    <template>
      <div class="chart-header">
        <div class="module-name" v-if="showModuleName">{{ moduleName }}</div>
        <div class="sub-title" v-if="showSubTitle">{{ subTitle }}</div>
      </div>
      <chart-filter-conditions
        :tableConditions="tableConditions"
        :tableHeader="tableHeader"
        @search="search"
      />
    </template>
    <ve-pie v-if="chartData.rows.length" :data="chartData"></ve-pie>
    <div class="chart-img-wrapper" v-else-if="!isType">
      <img
        src="https://imgcdn.hemiao100.com/decoration/ps7b895c9ae451a5a9-aee9-45b0-ba13-b8a8af971e4e.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import VePie from "v-charts/lib/pie.common";
import chartFilterConditions from "@/components/charts/chartFilterConditions";

export default {
  components: {
    VePie,
    chartFilterConditions
  },
  props: {
    employeeId: {
      type: String,
      default: ""
    },
    isType: {
      type: String,
      default: ""
    },
    configId: {
      type: String,
      default: ""
    },
    groupNameList: {
      type: Array,
      default: () => []
    },
    groupValueList: {
      type: Array,
      default: () => []
    },
    tableConditions: {
      type: Array,
      default: () => []
    },
    showModuleName: {
      type: Boolean,
      default: true
    },
    showSubTitle: {
      type: Boolean,
      default: true
    },
    moduleName: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      col: [],
      chartData: {
        columns: [],
        rows: []
      },
      tableHeader: []
    };
  },
  computed: {
    dataIsComplete() {
      return {
        groupNameList: this.groupNameList,
        groupValueList: this.groupValueList
      };
    }
  },
  watch: {
    dataIsComplete(val) {
      if (val.groupNameList.length && val.groupValueList.length) {
        this.tableHeader = this.groupNameList.concat(this.groupValueList);
        this.queryAnalyzeList();
      }
    }
  },
  created() {},
  mounted() {
    if (this.isType === "phone") {
      this.search();
    }
  },
  methods: {
    initData(data) {
      const keyMap = {};
      this.groupValueList.map(v => {
        keyMap[v.columnName] = v.labelName;
      });
      this.groupNameList.map(v => {
        keyMap[v.columnName] = v.labelName;
        if (v.associatedDictCode) {
          data.forEach(o => {
            o[v.associatedDictCode] =
              this.translation(v.associatedDictCode, o[v.columnName]) ||
              o[v.columnName];
          });
        }
      });

      let columns = [];
      for (let key in keyMap) {
        columns.push(keyMap[key]);
      }
      const rows = this.convertKey(data, keyMap);
      this.chartData = {
        columns: columns.reverse(),
        rows
      };
    },
    convertKey(arr, keyMap) {
      let tempString = JSON.stringify(arr);
      for (var key in keyMap) {
        var reg = `/"${key}":/g`;
        tempString = tempString.replace(eval(reg), '"' + keyMap[key] + '":');
      }
      return JSON.parse(tempString);
    },
    translation(code, columnName) {
      if (columnName) {
        if (this.$sysAllDict[code].find(o => o.value === columnName)) {
          return this.$sysAllDict[code].find(o => o.value === columnName).text;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    search() {
      if (!this.groupNameList.length) {
        this.$message({
          message: "请选择分组字段",
          type: "warning"
        });
        return;
      }
      if (!this.groupValueList.length) {
        this.$message({
          message: "请选择字段对应值",
          type: "warning"
        });
        return;
      }
      this.tableHeader = this.groupNameList.concat(this.groupValueList);
      this.queryAnalyzeList();
    },
    // async getTableData(tableId) {
    //   this.loading = true;
    //   try {
    //     const { code, result } = await this.$store.dispatch(
    //       "querySsrAnalysisQueueDetail",
    //       {
    //         queueId: tableId
    //       }
    //     );
    //     this.loading = false;
    //     if (code === "0") {
    //       if (!result.responseResultContent) {
    //         this.getTableData(tableId);
    //         return;
    //       }
    //       let tableDatas = JSON.parse(result.responseResultContent);
    //       tableDatas = tableDatas.slice(0, 200);
    //       this.$emit("setTableData", tableDatas);
    //       this.initData(tableDatas);
    //     }
    //   } catch (error) {
    //     this.loading = false;
    //   }
    // },
    async queryAnalyzeList() {
      let whereColumns = [];
      let selectColumns = [];
      let groupColumns = [];
      let falg = false;
      this.tableConditions.forEach(v => {
        if (v.isRequiredWhere === "yes") {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          }
        } else {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          }
        }
      });
      if (falg) {
        this.$message({
          message: "请填写完必填项",
          type: "warning"
        });
      } else {
        let show = false;
        const list = this.groupNameList.concat(this.groupValueList);
        list.forEach(v => {
          if (v.isAggregateColumn === "yes") {
            show = true;
          }
        });
        if (show) {
          this.tableHeader.forEach(v => {
            if (v.isAggregateColumn !== "yes") {
              groupColumns.push(v);
            }
          });
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
        } else {
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
        }
        whereColumns.forEach(v => {
          if (v.queryMode === "range") {
            if (v.columnType === "datetime") {
              v.queryStartValue = v.applyDate[0];
              v.queryEndValue = v.applyDate[1];
            }
          }
        });
        let tableHeader = {
          tableHeader: this.tableHeader,
          AllHeader: this.tableList
        };
        let params = {
          id: this.configId || this.$route.query.id,
          whereColumns,
          selectColumns,
          groupColumns,
          tableHeader: JSON.stringify(tableHeader),
          queryCondition: JSON.stringify(this.tableConditions),
          returnDataMode: "sync",
          mode: "dev"
        };
        this.loading = true;
        if (this.isType === "phone") {
          params.configId = this.configId;
          params.employeeId = this.employeeId;
          const { result, code } = await this.$store.dispatch(
            "addSsrAnalysisQueueByEmployeeId",
            params
          );
          if (code === "0") {
            this.isloading = false;
            let tableDatas = JSON.parse(result.responseResultContent);
            tableDatas = tableDatas.slice(0, 200);
            selectColumns.forEach(v => {
              if (v.associatedDictCode !== "") {
                tableDatas.forEach(k => {
                  k[v.associatedDictCode] = this.translation(
                    v.associatedDictCode,
                    k[v.columnName]
                  );
                });
              }
            });
            this.tableData = tableDatas;
            this.initData(tableDatas);
          }
        } else {
          const { result, code } = await this.$store.dispatch(
            "queryAnalyzeList",
            params
          );
          if (code === "0") {
            this.loading = false;
            // this.getTableData(result);
            let tableDatas = JSON.parse(result.responseResultContent);
            tableDatas = tableDatas.slice(0, 200);
            this.$emit("setTableData", tableDatas);
            this.initData(tableDatas);
          }
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.chart-header {
  background: #fff;
  padding: 15px;
  .module-name {
    font-size: 16px;
    font-weight: bold;
    line-height: 30px;
  }
  .sub-title {
    font-size: 14px;
  }
}
.chart-container {
  background: #fff;
  margin-bottom: 15px;
}
</style>
